// extracted by mini-css-extract-plugin
module.exports = {"custom-success-shipment":"successShipment_custom-success-shipment__20kT8"};